// src/components/ConversationRenamedListener.tsx
import { useEffect } from "react";
import { getSocket, trackRoom, untrackRoom } from "@/lib/socket";

/** Payload shape from the backend for conversation rename events */
export type RenameUpdate = {
  id: string;
  name: string | null;
};

export function ConversationRenamedListener({
  conversationId,
  onRename,
}: {
  conversationId: string;
  onRename: (u: RenameUpdate) => void;
}) {
  useEffect(() => {
    const s = getSocket();
    if (!s) return;

    trackRoom(conversationId); // join + auto-rejoin

    const handler = (payload: RenameUpdate) => {
      if (payload.id === conversationId) onRename(payload);
    };

    s.on("conversation:renamed", handler);
    return () => {
      if (!s) return;
      s.off("conversation:renamed", handler);
      untrackRoom(conversationId);
    };
  }, [conversationId, onRename]);

  return null;
}
